import React from 'react';
import {truncate} from 'lodash';
import {DATE_FORMATS, getDateByCustomFormat} from 'utils/date';

import {Table, Text} from '@phonectas/unifon-ui-kit';

export interface AttachmentsData {
    name?: string;
    sourceSystem?: string;
    timestamp?: string;
}

interface CaseAttachmentsTableRowProps {
    index: number;
    item: AttachmentsData;
}

const CaseAttachmentsTableRow: React.FC<CaseAttachmentsTableRowProps> = ({
	index,
	item,
}) => {
	return (
		<Table.Row
			index={index}
			key={index}
		>
			<Table.Cell>
				<Text variant="body">{truncate(item?.name, {length: 34})}</Text>
			</Table.Cell>
			<Table.Cell>
				<Text variant="body">{item?.sourceSystem?.split(' ')[0]}</Text>
			</Table.Cell>
			<Table.Cell>
				<Text variant="body">{getDateByCustomFormat(item?.timestamp, DATE_FORMATS.DD_MM_YY)}</Text>
			</Table.Cell>
		</Table.Row>
	);
}

export default CaseAttachmentsTableRow;
